import get_param from '../param'


export function isApp() {
  return /imgo/i.test(window.navigator.userAgent);
}

export function isWeiXin() {
  return /MicroMessenger/i.test(window.navigator.userAgent);
}

export function isAndroid() {
  return /android/i.test(window.navigator.userAgent);
}

export function isIphone() {
  return /iphone/i.test(window.navigator.userAgent);
}


export function isIpad() {
  return /ipad/i.test(window.navigator.userAgent);
}

export function isOTT() {
  return get_param('platform') === "1"
}

export function isSupportsWebP() {
  'use strict';
  const canvas = typeof document === 'object' ? document.createElement('canvas') : {};
  canvas.width = canvas.height = 1;
  return canvas.toDataURL ? canvas.toDataURL('image/webp').indexOf('image/webp') === 5 : false;
};


export function os(){
  return ''

}


export function getInvoker() {
  if (isApp()) {
    if (isIpad()) {
      return 'pad-ios'
    } else if (isIphone()) {
      return 'mobile-ios'
    } else {
      return 'mobile-android'
    }
  } else if (isWeiXin()) {
    return 'mobile-weixin'
  } else {
    return 'other'
  }
}

export function getPlatform() {
  if (isApp()) {
    if (isIphone()) {
      return 'iphone'
    } else if (isIpad()) {
      return 'ipad'
    } else {
      return 'android'
    }
  } else {
    if(isOTT()){
      return 'ott';
    }else{
      return 'h5';
    }
  }
}



// WEBPACK FOOTER //
// ./src/tools/mgtv/env.js